"use client";
import { useAgenda } from "@/contexts/agenda";
import { IEvent } from "@/types/event";
import dayjs from "dayjs";
import { ArrowRight } from "lucide-react";

export const EventMediumCard = ({ entry }: { entry: IEvent }) => {
  const { setEventId } = useAgenda();
  return (
    <div
      onClick={() => setEventId(entry.sys.id)}
      className="grid grid-cols-12 gap-4 xl:gap-8 group cursor-pointer"
    >
      <div className="col-span-4 bg-gray-100 overflow-hidden cursor-pointer">
        {entry.image && entry.image.url && (
          <img
            src={`${entry.image.url}?w=350&h=200&fit=fill`}
            alt={entry.image.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
        )}
      </div>
      <div className="col-span-8 space-y-4">
        <div className="flex">
          <p className="uppercase text-xs font-medium tracking-wide border-b-2 border-b-gray-600 flex space-x-2 items-center">
            {/* {entry.contentfulMetadata.tags.map((tag) => tag.name).join(", ")} */}
            <span>{dayjs(entry.startDate).format("DD/MM/YYYY")}</span>
            {entry.endDate && (
              <>
                <ArrowRight size={12} />
                <span>{dayjs(entry.endDate).format("DD/MM/YYYY")}</span>
              </>
            )}
          </p>
        </div>
        <div className="line-clamp-3">
          <h3
            className="font-light block group-hover:underline"
            onClick={() => setEventId(entry.sys.id)}
          >
            {entry.title}
          </h3>
        </div>
      </div>
    </div>
  );
};
